import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './compenents/Navbar'
import Home from './pages/Home'
import Services from './pages/Services'
import Conseil from './pages/Conseil'
import Accompagnement from './pages/Accompagnement'
import AISolutions from './pages/AISolutions'
import Partnerships from './pages/Partnerships'
import About from './pages/About'
import Contact from './pages/Contact'
import Footer from './compenents/Footer'
import WhatsAppButton from './compenents/WhatsAppButton'
import ScrollToTop from './compenents/ScrollToTop '
import Training from './pages/TrainingDomains '
import Recruitment from './pages/Recruitment'




function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Navbar />
       
        <ScrollToTop/>
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/conseil" element={<Conseil />} />
            <Route path="/accompagnement" element={<Accompagnement />} />
            <Route path="/ai-solutions" element={<AISolutions />} />
            <Route path="/partnerships" element={<Partnerships />} />
            <Route path="/training" element={<Training />} />
            <Route path="/recruitment" element={<Recruitment />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
         <WhatsAppButton />
      </div>
    </Router>
  )
}

export default App